import { render } from "./userProfilePosts.vue?vue&type=template&id=b9ae9a78&scoped=true"
import script from "./userProfilePosts.vue?vue&type=script&lang=js"
export * from "./userProfilePosts.vue?vue&type=script&lang=js"

import "./userProfilePosts.vue?vue&type=style&index=0&id=b9ae9a78&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9ae9a78"]])

export default __exports__